import React, { useState, useEffect } from 'react';

const CoreInput = React.memo(
  ({
    dataCy,
    className,
    placeholder = '',
    onKeyPress,
    type = 'text',
    maxLength = 999,
    newText = '',
    digits = '',
    textAllCaps = false,
    onFocus,
    onTextChange,
  }) => {
    const [state, setState] = useState({
      text: '',
    });

    const { text } = state;

    const onKeyChange = event => {
      if (event.key === 'Enter' && onKeyPress) {
        onKeyPress();
      }
    };

    const onChange = event => {
      const value = event.target.value;
      if (matchDigits(value) || isDeleteMode(value)) {
        setState({ text: displayText(value) });
        if (onTextChange) {
          onTextChange(displayText(value));
        }
      } else {
        setState({ text: displayText(text) });
      }
    };

    const isDeleteMode = value => {
      return value.length < text.length;
    };

    const matchDigits = value => {
      const latestChar = value.charAt(value.length - 1);
      if (digits !== '' && value !== '') {
        return latestChar.match(digits) !== null;
      } else {
        return true;
      }
    };

    const displayText = text => {
      if (textAllCaps) {
        return text.toUpperCase();
      } else {
        return text;
      }
    };

    useEffect(() => {
      if (text !== newText) {
        setState({ text: newText });
      }
    }, [newText]); //eslint-disable-line

    return (
      <input
        data-cy={dataCy}
        className={className}
        placeholder={placeholder}
        onChange={onChange}
        onKeyPress={onKeyChange}
        type={type}
        value={text}
        maxLength={maxLength}
        onFocus={onFocus}
      />
    );
  }
);

export default CoreInput;
